export enum HospitalityPaidBy {
  Bonliva = "Bonliva",
  Consultant = "Consultant"
}
